import React from 'react'
import { useParams } from 'react-router-dom'

import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { PageLayout } from '@components/common/PageLayout'
import { DashboardBackButton } from '@components/utils'
import { SECTION_NAMES } from '@constants/sectionNames'
import { ButtonClean, HeadContent, Loading, useModalContext } from '@fourthwall/components'
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop'
import { routing } from '@utils/routing'

import { ConnectBar } from '../../components/ConnectBar/ConnectBar'
import { SettingsIframe } from './components/SettingsIframe'
import { usePlatformApp } from './hooks/usePlatformApp'

export const AppsPlatformUnified = (props: { appId?: string }) => {
  const { app: appId } = useParams<'app'>()
  const { connectBar, isLoading, hmac, name, settingsUrl, description, learnMoreUrl } =
    usePlatformApp(props.appId || appId || '')
  const { currentShop } = useCurrentShop()
  const { open: openModal } = useModalContext()

  if (!connectBar || !currentShop) {
    return <Loading isLoading={isLoading} />
  }

  return (
    <>
      <HeadContent title={name} />
      <PageLayout size="tiny">
        <Dashboard.Section
          name={name}
          topContent={<DashboardBackButton label={SECTION_NAMES.apps} to={routing.apps.self} />}
          bottomContent={
            <p>
              {description}{' '}
              {learnMoreUrl && (
                <ButtonClean label="Learn More" href={learnMoreUrl} target="_blank" />
              )}
            </p>
          }
        >
          <Loading isLoading={isLoading}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <ConnectBar {...connectBar} />
              {hmac && settingsUrl ? (
                <SettingsIframe
                  hmac={hmac}
                  shopId={currentShop?.id}
                  openModal={openModal}
                  settingsUrl={settingsUrl}
                  name={name || ''}
                />
              ) : (
                <p />
              )}
            </div>
          </Loading>
        </Dashboard.Section>
      </PageLayout>
    </>
  )
}
